module.exports = __webpack_public_path__ + "img/handle.f35ef056.png";